<script>
    import IfeSpot from "./IfeSpot.svelte";
    import {
        selectedRegion,
        selectedField,
        expandAll,
        selectedLocality,
    } from "../Stores";
    import { getSpotsString, nSpotsPerLocality } from "../Utils";

    export let year;
    export let locality;
    export let institutions;
    export let region;
    export let field;

    const nSpots = getNSpots();

    let isExpanded = false;

    function getNSpots() {
        const nSpots = institutions.reduce(
            (acc, { n_spots }) => acc + n_spots,
            0
        );
        if (locality in nSpotsPerLocality) {
            nSpotsPerLocality[locality][year] = nSpots;
        } else {
            nSpotsPerLocality[locality] = {
                [year]: nSpots,
            };
        }

        return nSpots;
    }

    function toggleExpand() {
        isExpanded = !isExpanded;
    }

    $: {
        isExpanded =
            region === $selectedRegion ||
            field === $selectedField ||
            locality === $selectedLocality ||
            $expandAll;
    }
</script>

<div class="mb-1">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <h6
        class="md:text-lg text-sm ml-4 font-semibold cursor-pointer hover:font-bold"
        on:click={toggleExpand}
    >
        {locality}
        <span class=" md:text-sm text-xs font-normal not-italic">
            ({nSpots}
            {getSpotsString(nSpots)})
        </span>
    </h6>
    {#if isExpanded}
        {#each institutions as institution}
            <IfeSpot {institution} />
        {/each}
    {/if}
</div>
